export type Treatment = {
  slug: string
  name: string
  tagline: string
  description: string
  duration: string
  price: string
  kuur?: string
  focus: string[]
  category: 'Anti-ageing' | 'Huidverbetering' | 'Ontspanning' | 'Losse applicaties'
  bindweefsel?: boolean
  signature?: boolean
}

export const treatments: Treatment[] = [
  {
    slug: 'cosmic-botox',
    name: 'Cosmic Botox',
    tagline: 'Lift zonder prikken of snijden',
    description:
      'Geen botuline, maar bindweefselmassage, ontspanningsmassage en energy work in één. De gezichtsspieren ontspannen, de doorbloeding komt op gang en het zelfhelend vermogen wordt geactiveerd. Helpt bij hangende oogleden, verslapping, vermoeide ogen en fijne lijntjes — met subtiel vollere lippen en strakkere contouren als resultaat.',
    duration: '75 min',
    price: 'Alleen als kuur',
    kuur: '3 × 75 min · € 450',
    focus: ['Verslapping', 'Vermoeide ogen', 'Fijne lijntjes'],
    category: 'Anti-ageing',
    bindweefsel: true,
    signature: true,
  },
  {
    slug: 'goddess-lift',
    name: 'Goddess Lift',
    tagline: 'Protocell peel-off masker met appelstamcellen',
    description:
      'De ultieme relax-ervaring. Het bijzondere masker op basis van Zwitserse organisch geteelde appelstamcellen — appeltjes die nooit rimpelen — wordt met peptiden je huid ingesluisd. Een glow waar je dagenlang van geniet. Inclusief bindweefselmassage.',
    duration: '80 min',
    price: '€ 135',
    kuur: '6 × 80 min · € 635',
    focus: ['Glow', 'Anti-ageing', 'Diepe ontspanning'],
    category: 'Anti-ageing',
    bindweefsel: true,
    signature: true,
  },
  {
    slug: 'restoration-of-juvenation',
    name: 'Restoration of Juvenation',
    tagline: 'Twee uur: huidverzorging én energetische healing',
    description:
      'Believe the hype. Een basisbehandeling gecombineerd met zestig minuten energetische healing en facelift. Door het weefsel onder druk te zetten komt hyaluronzuur vrij, worden collageen en elastine geactiveerd en voeren we afvalstoffen af. De gymles voor je huid, in de meest ontspannen vorm.',
    duration: '120 min',
    price: '€ 180',
    focus: ['Anti-ageing', 'Energetisch werk', 'Volledige reset'],
    category: 'Anti-ageing',
    bindweefsel: true,
    signature: true,
  },
  {
    slug: 'get-the-red-out',
    name: 'Get the Red Out',
    tagline: 'Voor roodheid en ontstekinkjes',
    description:
      'Kalmeert een huid die rood aanloopt en snel ontstoken raakt. Inclusief bindweefselmassage en, als je dat wilt, een applicatie zoals het verven of suikeren van bovenlip of wenkbrauwen.',
    duration: '75 min',
    price: '€ 99',
    focus: ['Roodheid', 'Ontstekingen', 'Gevoelige huid'],
    category: 'Huidverbetering',
    bindweefsel: true,
  },
  {
    slug: 'vitamine-c-behandeling',
    name: 'Vitamine C Behandeling',
    tagline: 'Gericht op pigmentatie',
    description:
      'Werkt aan een egalere teint bij pigmentvlekken, met de stabiele stay-C formule van emerginC. Inclusief bindweefselmassage en ruimte voor extra applicaties.',
    duration: '75 min',
    price: '€ 99',
    kuur: '6 × 75 min · € 485',
    focus: ['Pigmentatie', 'Egale teint', 'Hormonale huid'],
    category: 'Huidverbetering',
    bindweefsel: true,
  },
  {
    slug: 'ibiza-behandeling',
    name: 'Ibiza Special',
    tagline: 'Alsof je een vakantie hebt gehad',
    description:
      'Gun je jezelf even tijd. Zestig minuten huidverzorging en ontspanning met een heerlijke gezichtsmassage. De ultieme basisbehandeling wanneer je op zoek bent naar een quick fix in ontspanning.',
    duration: '60 min',
    price: '€ 85',
    focus: ['Ontspanning', 'Alle huidtypes', 'Kennismaking'],
    category: 'Ontspanning',
    signature: true,
  },
  {
    slug: 'bindweefselmassage-los',
    name: 'Bindweefselmassage',
    tagline: 'Losse applicatie van 25 minuten',
    description:
      'De fitnessoefening voor je huid, ook los te boeken. Aan te raden in kuurvorm: om de drie weken een afspraak.',
    duration: '25 min',
    price: '€ 45',
    focus: ['Anti-ageing', 'Doffe huid', 'Doorbloeding'],
    category: 'Losse applicaties',
    bindweefsel: true,
  },
  {
    slug: 'persian-delight',
    name: 'Persian Delight',
    tagline: 'Wimpers & wenkbrauwen verven en epileren',
    description:
      'Een scherpe blik zonder make-up. Verven en in model brengen van wimpers en wenkbrauwen.',
    duration: '30 min',
    price: '€ 45',
    focus: ['Wenkbrauwen', 'Wimpers'],
    category: 'Losse applicaties',
  },
  {
    slug: 'shelfie-time',
    name: 'Shelfie Time',
    tagline: 'Kennismaking en huidadvies, ook online',
    description:
      'Laat zien wat er in je badkamerkastje staat. Samen kijken we wat je huid nodig heeft en wat weg mag — vrijblijvend en zonder verkooppraatje.',
    duration: '30 min',
    price: 'Gratis',
    focus: ['Advies', 'Thuisroutine'],
    category: 'Losse applicaties',
  },
]

export const bindweefsel = {
  title: 'Bindweefselmassage',
  claim: 'De fitnessoefening voor je huid',
  intro:
    'Vrijwel elke behandeling bij Beauty Bewust bevat een bindweefselmassage. Door met kleine kneepjes het weefsel onder druk te zetten komt hyaluronzuur vrij, worden collageen en elastine geactiveerd en voeren we afvalstoffen af. Zuurstof bereikt de bovenste huidlaag weer.',
  rhythm: 'In kuurvorm om de drie weken een afspraak.',
  forWho: [
    'Je wilt werken aan anti-ageing',
    'Je huid is dof en voelt onregelmatig aan',
    'Je ziet (beginnende) lijntjes',
    'Je bent klaar voor een stralende teint',
  ],
  effects: [
    'Aanmaak van collageen en elastine bevorderen',
    'Zuurstof en hyaluronzuur naar de bovenste huidlaag brengen',
    'Afvalstoffen afvoeren door de doorbloeding te stimuleren',
  ],
}

export const treatmentIncludes = [
  'Oppervlaktereiniging',
  'Dieptereiniging met peeling',
  'Massage',
  'Masker',
  'Dagverzorging',
]
